// Triggering app
import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import app from 'bundles/widget-simulator/app';

export default appStarterFactory(app);
